import { styled } from "styled-components";

export const HolidayCalenderBody = styled.div`
    display: flex;
    flex-direction: column;
    margin : 100px 100px 100px 250px;
`